import request from '../utils/request';

export const goodsAuditQueueApi = {
  /**
   * 分页查询商品审核队列
   * @param {Object} params - 查询参数
   * @param {number} params.page - 页码
   * @param {number} params.pageSize - 每页条数
   * @param {Object} params.queryParams - 查询条件
   * @returns {Promise} 商品审核队列分页数据
   */
  pageGoodsAuditQueues: (params) => {
    return request({
      url: '/goods-audit-queue/page',
      method: 'get',
      params: {
        page: params.page || 1,
        pageSize: params.pageSize || 10,
        ...params.queryParams
      }
    });
  },

  /**
   * 获取商品审核队列详情
   * @param {number} goodsAuditQueueId - 商品审核队列ID
   * @returns {Promise} 商品审核队列详情
   */
  getGoodsAuditQueueDetail: (goodsAuditQueueId) => {
    return request({
      url: `/goods-audit-queue/${goodsAuditQueueId}`,
      method: 'get'
    });
  },

  /**
   * 添加商品审核队列
   * @param {Object} data - 商品审核队列数据
   * @returns {Promise} 添加结果
   */
  addGoodsAuditQueue: (data) => {
    return request({
      url: '/goods-audit-queue',
      method: 'post',
      data
    });
  },

  /**
   * 更新商品审核队列
   * @param {Object} data - 商品审核队列数据
   * @returns {Promise} 更新结果
   */
  updateGoodsAuditQueue: (data) => {
    return request({
      url: `/goods-audit-queue/${data.id}`,
      method: 'put',
      data
    });
  },

  /**
   * 删除商品审核队列
   * @param {number} goodsAuditQueueId - 商品审核队列ID
   * @returns {Promise} 删除结果
   */
  deleteGoodsAuditQueue: (goodsAuditQueueId) => {
    return request({
      url: `/goods-audit-queue/${goodsAuditQueueId}`,
      method: 'delete'
    });
  },

  /**
   * 审核商品
   * @param {Object} auditData - 审核数据
   * @returns {Promise} 审核结果
   */
  auditGoods: (auditData) => {
    return request({
      url: '/goods-audit-queue/audit',
      method: 'post',
      data: {
        auditStatus: auditData.auditStatus,
        auditReason: auditData.auditReason,
        goodsAuditQueueId: auditData.id
      }
    });
  }
};

export default goodsAuditQueueApi; 